export default {
  animateObj: {
    value: 0,
    animate: {
      _key: 'none'
    }
  },
  //module的样式用pc_infor和mb_infor
  //挂件内部的用pc_widgets_infor和mb_widgets_infor
  pc_infor:{
    marginTop:'0%',
    marginLeft:'0%',
    marginRight:'0%',
    marginBottom:'0%',
  },
  mb_infor:{
    marginTop:'0%',
    marginLeft:'0%',
    marginRight:'0%',
    marginBottom:'0%',
  },
};



// WEBPACK FOOTER //
// ./src/widgets/basic_module/style.js